"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIRECT_PAYMENT_SUBSCRIPTION_STATUS = void 0;
var DIRECT_PAYMENT_SUBSCRIPTION_STATUS;
(function (DIRECT_PAYMENT_SUBSCRIPTION_STATUS) {
    DIRECT_PAYMENT_SUBSCRIPTION_STATUS["CANCELED"] = "canceled";
})(DIRECT_PAYMENT_SUBSCRIPTION_STATUS = exports.DIRECT_PAYMENT_SUBSCRIPTION_STATUS || (exports.DIRECT_PAYMENT_SUBSCRIPTION_STATUS = {}));
